import React from 'react';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';
import { Button } from 'components/buttons/Button';

export const outletColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_numbering,
    getColumns_outletName,
    getColumns_dateStarted,
    getColumns_chargeMethod,
    getColumns_monthlyCharges,
}

function getColumns() {
    return [
        getColumns_numbering(),
        getColumns_outletName(),
        getColumns_dateStarted(),
        getColumns_chargeMethod(),
        getColumns_monthlyCharges(),
    ];
}

function getColumns_numbering() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-numbering";

    return {
        headerCellClassName: columnClassName + " ",
        id: "numbering",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let rowObj = func_validation.getObjectPropertyValue(props, "row");
            let rowIdx = func_validation.getObjectPropertyValue(rowObj, "index");
            rowIdx += 1;

            return (
                <div className={"noWrap-text-ellipsis"}>{rowIdx}</div>
            );
        },
        width: 80
    }
}


function getColumns_outletName() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-outletName";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Outlet",
        // isHeaderColumnSortable: true,
        // sortValue: "license"
        id: "outletName",
        accessor: "Value",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_dateStarted() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-dateStarted";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Date Started",
        // isHeaderColumnSortable: true,
        // sortValue: "dateStarted"
        id: "dateStarted",
        accessor: "CreationDate",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = "-";
            if (!isNaN(new Date(value)))
                value_formatted = func_datetime.convertDateTimeToLocal(value, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_chargeMethod() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-chargeMethod";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Charging Method",
        // isHeaderColumnSortable: true,
        // sortValue: "chargeMethod"
        id: "chargeMethod",
        accessor: "chargeMethod",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_monthlyCharges() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-monthlyCharges";

    return {
        headerCellClassName: columnClassName + " justify-content-end",
        Header: "Monthly Charges",
        // isHeaderColumnSortable: true,
        // sortValue: "monthlyCharges"
        id: "monthlyCharges",
        accessor: "monthlyCharges",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = "-";
            if (func_validation.isNumberValid(value)) {
                value_formatted = func_cookieSetting.getFormattedPrice(value, { currencyDisabled: true });
            }

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}